export const sidebarData = [
  {
    title: "Dashboard",
    darkIcon: "/static/DarkMode/overview.svg",
    lightIcon: "/static/LightMode/overview.svg",
    enableDarkIcon: "/static/DarkMode/dashboard-icon-active1.svg",
    enableLightIcon: "/static/LightMode/dashboard-icon-active2.svg",
    link: "/home",
    width: 20,
  },
  {
    title: "Spy Search",
    darkIcon: "/static/DarkMode/spysearch.svg",
    lightIcon: "/static/LightMode/spysearch.svg",
    enableDarkIcon: "/static/DarkMode/spy-icon-active1.svg",
    enableLightIcon: "/static/LightMode/spy-icon-active2.svg",
    link: "/spySearch",
    width: 20,
  },
  {
    title: "A2A Flips",
    darkIcon: "/static/DarkMode/a2aflip.svg",
    lightIcon: "/static/LightMode/a2aflip.svg",
    enableDarkIcon: "/static/DarkMode/amazon-active1.svg",
    enableLightIcon: "/static/LightMode/amazon-active2.svg",
    link: "/a2aFlips",
    width: 20,
  },
  {
    title: "Preiswecker",
    darkIcon: "/static/DarkMode/preiswecker-inactive1.svg",
    lightIcon: "/static/LightMode/preiswecker-inactive2.svg",
    enableDarkIcon: "/static/DarkMode/preiswecker-active1.svg",
    enableLightIcon: "/static/LightMode/preiswecker-active2.svg",
    link: "/preiswecker",
    width: 20,
  },  
  {
    title: "Wholesale Wizard",
    darkIcon: "/static/DarkMode/wholesale-icon-inactive-dk.svg",
    lightIcon: "/static/LightMode/wholesale-icon-inactive-lt.svg",
    enableDarkIcon: "/static/DarkMode/wholesale-icon-active-dk.svg",
    enableLightIcon: "/static/LightMode/wholesale-icon-active-lt.svg",
    link: "/wholesale",
    width: 20,
  },
  {
    title: "Einstellungen",
    darkIcon: "/static/DarkMode/settings-inactive1.svg",
    lightIcon: "/static/LightMode/settings-inactive2.svg",
    enableDarkIcon: "/static/DarkMode/settings-active1.svg",
    enableLightIcon: "/static/LightMode/settings-active2.svg",
    link: "/settings",
    width: 20,
  },
  {
    title: "Edge Academy",
    darkIcon: "/static/DarkMode/guide.svg",
    lightIcon: "/static/LightMode/guide.svg",
    enableDarkIcon: "/static/DarkMode/academy-active1.svg",
    enableLightIcon: "/static/LightMode/academy-active2.svg",
    link: "/guide",
    width: 20,
  },
];
